import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { bankAccountDisplayDetails } from '../state/SpacesAtoms';
import useGetAllBankAccountDetails from './useGetAllBankAccountDetails';

const useGetAllBankAccountDetailsFromGlobalState = () => {
    const [allDetails, setAllDetails] = useAtom(bankAccountDisplayDetails);

    const { bankAccountDetails, isLoading } = useGetAllBankAccountDetails(
        !allDetails.length,
    );

    useEffect(() => {
        if (!isLoading) {
            setAllDetails(bankAccountDetails);
        }
    }, [JSON.stringify(bankAccountDetails), isLoading]);

    return { bankAccountDetails: allDetails, isLoading };
};

export default useGetAllBankAccountDetailsFromGlobalState;
